/* unplugin-vue-components disabled */import script from "./NavChannelIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./NavChannelIcon.vue?vue&type=script&setup=true&lang=js"

import "./NavChannelIcon.vue?vue&type=style&index=0&id=867914d2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-867914d2"]])

export default __exports__